<div class="fullcontainer">
  @if (this.isError) {
 
  }
  @if (this.isForbidden) {

  }
  @if (this.isServerError) {
    <div class="alert alert-danger">
      @if (this.serverErrorMessage) {
        {{ this.serverErrorMessage }}
      } @else {
        Something went wrong. Please try again later.
      }
    </div>
  }

  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Revalue stock</h1>
      <div>
        <button class='btn btn-secondary' routerLink='/warehousing/cost-history'><i class="fas fa-history"></i> Cost History</button>&nbsp;
        <button class='btn btn-secondary' routerLink='/warehousing/stock-levels'><i class="fas fa-layer-group"></i> Stock Levels</button>&nbsp;
      </div>
    </div>

    <!-- The likeliest operator error on this screen is expecting a revaluation to fix a quantity, so
         the warning is the first thing on it and it names the screen that does do that. -->


    <!-- alert-warning rather than alert-secondary: Bootstrap is not installed here, so
         `alert-secondary` matches nothing and `.alert { color: white }` leaves the text invisible. -->
    @if (!this.canRevalue()) {

    }

    <form (ngSubmit)='this.onSubmit()' method='post'>

      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Reference</label>
          <select class='form-control' [class.is-invalid]='this.revaluation.referenceId === -1'
            (change)='this.onReferenceChanged($event.target.value)'>
            <option value='-1'>Select a reference</option>
            @for (item of this.references; track item) {
              <option [value]='item.id' [selected]='this.revaluation.referenceId === item.id'>{{ item.name }}</option>
            }
          </select>
          <!-- A REVALUATION code (id 13) has since been added to the lookup, so the steer is no
               longer towards Stocktake as the closest available fit - verified live against
               `product-stock-movement-reference`, which the picker reads unfiltered. Still a steer
               rather than a restriction: the reference is the operator's reason for the correction
               and Stocktake or Damaged can be the truer one. -->
        </div>
        <div class="form-group col-md-4">
          <label>Warehouse</label>
          <select class='form-control' [class.is-invalid]='this.warehouseId === -1'
            (change)='this.onWarehouseChanged($event.target.value)'>
            <option value='-1'>Select a warehouse</option>
            @for (item of this.warehouses; track item) {
              <option [value]='item.id' [selected]='this.warehouseId === item.id'>{{ item.name }}</option>
            }
          </select>
          <!-- Says what it scopes and, just as importantly, what it does not. This select chooses
               the location recorded on the line; it has no bearing on the stock being valued. -->

        </div>
      </div>

      <h3>Lines</h3>


      <!-- The location column invites precisely the wrong reading, so the point is made three ways:
           in this copy, in the column heading, and structurally by the holding panel under the
           table - which lists every location the product sits in, at every site, unfiltered by the
           warehouse chosen above. Somebody who read the figure as belonging to the shelf they had
           just inspected would wipe the value of that product's stock in another warehouse. -->


      <table class='table'>
        <thead>
          <th>Product</th>
          <th>Location <small class='text-muted'>(audit only)</small></th>
          <th>Whole holding worth today</th>
          <th>Stated value (£, whole holding)</th>
          <th>What that moves</th>
          <th></th>
        </thead>
        <tbody>
          <!-- lines already added -->
          @for (line of this.revaluation.lines; track line; let i = $index) {
            <tr>
              <td>{{ this.getProductName(line.productId) }}</td>
              <td>{{ this.getLocationName(line.warehouseLocationId) }}</td>
              <td>{{ this.getLineCurrentValue(line) }}</td>
              <td>{{ this.getFormattedTargetValue(line.targetValue) }}</td>
              <!-- A write-down is marked three ways and never by colour alone: the amount itself
                   reads "-£250.00", there is a downward arrow, and the words are spelled out. The
                   colour is applied inline from the shared status token because `text-danger` is not
                   defined in this project's stylesheet - Bootstrap is not installed - so a class
                   would have silently done nothing and left a write-down looking like a write-up.

                   The cell reports the MOVEMENT, which the stated value no longer carries on its
                   face: 500 is a write-down against a holding worth 900 and a write-up against one
                   worth 100, and the line alone cannot be read either way. -->
              <td [style.color]='this.isLineWriteDown(line) ? this.statusCritical : null'>
                @if (this.isLineChangeKnown(line)) {
                  {{ this.getLineChange(line) }}
                  @if (this.isLineWriteDown(line)) {
                    <i class="fas fa-arrow-down"></i> <strong>write-down</strong>
                  }
                } @else {
                  <span class='text-muted'>Not known &mdash; see the holding below</span>
                }
              </td>
              <td>
                <button class='btn btn-danger' type="button" (click)='this.deleteLine(i)'><i class="fas fa-trash"></i></button>
              </td>
            </tr>
          }

          <!-- new line. There is deliberately no quantity input here: a revaluation posts a quantity
               of zero, and an operator who typed one would reasonably expect stock to change. -->
          <tr>
            <td>
              <select class='form-control'
                [class.is-invalid]='this.newLine.productId === -1'
                (change)='this.onNewLineProductChanged($event.target.value)'>
                <option value='-1'>Select a product</option>
                @for (item of this.products; track item) {
                  <option [selected]='this.newLine.productId === item.id' [value]='item.id'>{{ item.name }}</option>
                }
              </select>
            </td>
            <!-- Typed, not picked, and resolved by the same service the operation form uses so that
                 one code means one shelf on every screen that takes one. The operator is reading the
                 code off the holding panel above and copying it into the line, which is a keyboard
                 action. An ambiguous or unknown code resolves to nothing rather than to a guess.

                 This changes nothing about what the location MEANS here - it still scopes no money,
                 exactly as the copy above says. Only how it is entered. -->
            <td>
              <input class='form-control' type='text' maxlength='64'
                placeholder='Location code'
                [class.is-invalid]='this.newLine.warehouseLocationId === -1'
                [disabled]='this.warehouseId === -1'
                [value]='this.locationText'
                (input)='this.onLocationTextChanged($event.target.value)'>
              @if (this.resolvedLocationLabel()) {
                <small class='text-success'>{{ this.resolvedLocationLabel() }}</small>
              }
              @if (this.locationError()) {
                <small class='text-danger'>{{ this.locationError() }}</small>
              }
            </td>
            <td>
              @if (this.holding !== null) {
                {{ this.getHoldingValue() }}
              } @else if (this.loadingHolding) {
                <i class="fas fa-spinner fa-spin"></i>
              }
            </td>
            <td>
              <!-- No minus sign in the placeholder, and that matters: the old field took one and the
                   habit it built is the single likeliest way to get this screen wrong now. -->
              <input name='newtargetvalue' type='number' step='0.01' min='0' class='form-control'
                placeholder='e.g. 500.00 - or 0 if it is worth nothing'
                [class.is-invalid]='this.isTargetValueInvalid(this.newLine)'
                [(ngModel)]='this.newLine.targetValue'
                (blur)='this.onTargetValueChanged(this.newLine)' />
            </td>
            <td [style.color]='this.isLineWriteDown(this.newLine) ? this.statusCritical : null'>
              @if (this.isTargetValueSupplied(this.newLine) && this.isLineChangeKnown(this.newLine)) {
                {{ this.getLineChange(this.newLine) }}
                @if (this.isLineWriteDown(this.newLine)) {
                  <i class="fas fa-arrow-down"></i> <strong>write-down</strong>
                }
              }
            </td>
            <td>
              <button class='btn btn-success' type='button' (click)='this.addLine()'><i class="fas fa-plus"></i></button>
            </td>
          </tr>
        </tbody>
      </table>

      @if (this.loadingHolding) {
        <p class='m-0'><i class="fas fa-spinner fa-spin"></i> Loading the whole holding&hellip;</p>
      }

      <!-- The panel that makes the product-wide reading impossible to miss. It is rebuilt rather
           than updated when the product changes - `holding` goes null first - so one product's
           locations can never sit under another product's name while a request is in flight. -->
      @if (this.holding !== null) {
        <h3>The whole holding you are valuing: {{ this.getProductName(this.newLine.productId) }}</h3>

        <p class='text-muted'>
          Every location this product sits in, at every site. This list is deliberately
          <strong>not</strong> filtered by the warehouse selected above, because the value stated is
          not filtered by it either.
        </p>

        <h3>ON HAND: {{ this.getHoldingQty() }} unit(s) across {{ this.getHoldingLocationCount() }} location(s)</h3>
        <h3>WORTH TODAY: {{ this.getHoldingValue() }}</h3>

        @if (this.doesHoldingHoldNoStock()) {

        }

        <!-- Was an alert-danger announcing a refusal. The backend stopped refusing this case when a
             stated value became a checkpoint: a holding nobody priced is exactly what this screen
             establishes a cost basis for, so warning the operator off it turned the one screen that
             fixes the problem into the one screen that appears to forbid it. -->
        @if (this.doesHoldingHaveNoCostBasis()) {

        }

        <!-- Suppressed when there is no cost basis at all: that case has its own alert above and is
             a refusal rather than a caveat, and stacking the two says the same thing twice. -->
        @if (this.isHoldingValueIncomplete() && !this.doesHoldingHaveNoCostBasis()) {

        }

        <!-- The only reassuring sentence on this screen. Any check that this panel is honest has to
             assert this text is ABSENT when it does not hold: asserting that a warning appears
             would pass just as well against code that rendered both at once, which is how £1,000 of
             stock came to be reported as fully covered on the dashboard. -->
        @if (this.doesHoldingValueCoverEverything()) {

        }

        <app-grid
          entity='revaluation-holding'
          [columns]='this.holdingColumns'
          [customDataSource]='this.getHoldingRecords.bind(this)'
          [showSearch]='false'
        ></app-grid>
      }

      <!-- What replaced the old "net value adjustment" row. That figure added up signed deltas and
           answered "how much money does this batch move", which a stated value simply does not
           carry: 500 is a write-down against a holding worth 900 and a write-up against one worth
           100. So the two questions are now asked separately, and the second one is allowed to go
           unanswered rather than be approximated. -->
      @if (this.revaluation.lines.length > 0) {
        <h3>
          TOTAL STATED VALUE: {{ this.getTotalStatedValue() }}
        </h3>
        <p class='text-muted'>
          What these {{ this.revaluation.lines.length }} holding(s) will be worth once this is
          posted. It is <strong>not</strong> the amount of money moving, and it is only addable at
          all because a product can appear once.
        </p>

        @if (this.isNetChangeKnown()) {
          <h3 [style.color]='this.isNetWriteDown() ? this.statusCritical : null'>
            THIS MOVES: {{ this.getNetChange() }}
            @if (this.isNetWriteDown()) {
              <i class="fas fa-arrow-down"></i> <strong>write-down</strong>
            }
          </h3>
        } @else {

        }
      }

      <button type="submit" class="btn btn-success">Post revaluation</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/cost-history'>Cancel</button>
    </form>


    <!-- This paragraph previously said the stated value drifted from the next goods-in onwards, and
         described the delta being replayed over lifetime intake as the mechanism. That was the model
         this screen was rebuilt to remove: a stated value is now a checkpoint in an ordered replay
         and is not diluted by anything arriving after it. The wording must not go back.

         It then said the holding "is worth more than the figure entered here once it has been topped
         up", which is true and still the wrong sentence to put in front of an operator who has just
         been told a stated value drifts. Read quickly it is the holding's worth parting company with
         what was entered, which is drift described from the other side. What the reader has to take
         away is that nothing later touches these units, so the units now lead and the arithmetic of
         a later delivery follows as an addition rather than as a difference. -->

  </div>
</div>
